import { render, staticRenderFns } from "./cargoList.vue?vue&type=template&id=0005273a"
import script from "./cargoList.vue?vue&type=script&lang=js"
export * from "./cargoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports